<div class="parking-slot">

  <div *ngIf="ownerManagerRedirection()" class="card breadcrumbs">
    <div class="common-justify-wrap card-container purple-container">

      <ul class="list-none breadcrumbs-outer">
        <li class="active-dashboard">
          <a [routerLink]="['/manager/dashboard']" class=" no-underline line-height-3 cursor-pointer ">Dashboard</a>
        </li>
        <li class="px-2 breadcrumbs-divider">
          <span>|</span>
        </li>
        <li class="back-link">
          <a [routerLink]="['/manager/parking']" class=" no-underline line-height-3 cursor-pointer ">Parking
            Locations</a>
        </li>
        <li class="px-2 breadcrumbs-divider">
          <span>|</span>
        </li>
        <li class="current-link">
          <span class=" line-height-3">Create Parking</span>
        </li>
      </ul>
    </div>
  </div>
  <p-toast></p-toast>
  <div [formGroup]="parkingSlotForm" class="grid">
    <div class="col-12 md:col-6 pb-0">
      <div class="box-card card">
        <div class="create-parking-slot">
          <div class="top-card">
            <div class="parking-lots-outer">
              <h3>Create Parking</h3>
            </div>

            <div class="slot-tabs">
              <ul>
                <li [ngClass]="{'tabs-active': selectedTab === 'defineSlots'}"
                  (click)="toggleIsParkAnywhere();selectedTab = 'defineSlots'">
                  Define spots</li>
                <li [ngClass]="{'tabs-active': selectedTab === 'parkAnywhere'}"
                  (click)="toggleIsParkAnywhere();selectedTab = 'parkAnywhere'">
                  Park anywhere</li>
              </ul>
            </div>
          </div>
        </div>

        <div class="grid thersold">
          <div class="col-12 md:col-6 custom-spacing-right">
            <div class="left-lable">
              Total Number of Spots <span class="custom-star">*</span>
            </div>

            <p-inputNumber inputId="locale-user" formControlName="totalSlots" placeholder="0"></p-inputNumber>
            <div
              *ngIf="parkingSlotForm.get('totalSlots')?.hasError('required')  && (parkingSlotForm.get('totalSlots')?.dirty || parkingSlotForm.get('totalSlots')?.touched)">
              <div class="validation-error"> This field is required*</div>
            </div>
            <div
              *ngIf="parkingSlotForm.get('totalSlots').hasError('lessThanThousand') && parkingSlotForm.get('totalSlots').touched && parkingSlotForm.get('totalSlots').dirty">
              <div class="validation-error">Spots cannot exceed 999</div>
            </div>

          </div>
          <div class="col-12 md:col-6">
            <div class="left-lable threshold-icon">
              Threshold (%) <span class="custom-star">*</span>
              <em [pTooltip]="tooltipContent" tooltipPosition="top" class="pi pi-info-circle"></em>
              <ng-template #tooltipContent>
                <div class="flex align-items-center tooltip-text">
                  <p>
                    The "Threshold value" refers to a predefined level of parking lot occupancy and Trucklots notifies
                    you when parking lot occupancy reaches the mentioned Threshold value.
                  </p>
                </div>
              </ng-template>
            </div>
            <input pInputText class="common-input" (keypress)="onKeyPress($event)" inputId="locale-user" placeholder=""
              formControlName="thresholdValue">
            <div
              *ngIf="parkingSlotForm.get('thresholdValue')?.hasError('required') && (parkingSlotForm.get('thresholdValue')?.dirty || parkingSlotForm.get('thresholdValue')?.touched)">
              <div class="validation-error">This field is required*</div>
            </div>

            <div
              *ngIf="parkingSlotForm.get('thresholdValue')?.value === 0 && (parkingSlotForm.get('thresholdValue')?.dirty || parkingSlotForm.get('thresholdValue')?.touched)">
              <div class="validation-error">Threshold should be greater than 0</div>
            </div>
            <div
              *ngIf="parkingSlotForm.get('thresholdValue')?.hasError('lessThanHundred')  && (parkingSlotForm.get('thresholdValue')?.dirty || parkingSlotForm.get('thresholdValue')?.touched)">
              <div class="validation-error">Threshold cannot exceed 100%</div>
            </div>
          </div>
        </div>

        <div class="row-divider" formArrayName="truckTypeArray"
          *ngFor="let truck of truckTypeArray()?.controls; let i=index"
          [style.display]="selectedTab === 'defineSlots' ? 'block' : 'none'">
          <div [formGroupName]="i">

            <div class="common-flex-between no-slot">

              <div class="left-lable">

                <div class="left-lable">

                  {{spotTypeMsg}} <span class="custom-star">*</span>

                </div>

                <div class="right-input ">

                  <label [for]="truck.get('truckName')!.value">{{truck.get('truckName')!.value }}</label>

                </div>

              </div>

              <div class="right-input custom-rightinput">
                <input avoidStartingZero (change)="soltChange(truck)" pInputText pKeyFilter="int" placeholder="0"
                  inputId="locale-user" formControlName="totalSlots">
                <div
                  *ngIf="truck.get('totalSlots')?.hasError('required')  && (truck.get('totalSlots')?.dirty || truck.get('totalSlots')?.touched)">
                  <div class="validation-error"> This field is required*</div>
                </div>
                <div
                  *ngIf="truck.get('totalSlots').hasError('lessThanThousand') && truck.get('totalSlots').touched && truck.get('totalSlots').dirty">
                  <div class="validation-error">Cannot exceed 999</div>
                </div>

              </div>

            </div>

            <div class="badge-box" formArrayName="parkingSlots">

              <h4>Spots Range</h4>
              <div class="slout-outer">
                <span *ngFor="let slot of parkingSlotArray(i)?.controls; let slotIndex=index">
                  <span [formGroupName]="slotIndex">
                    <input pInputText styleClass="mr-2 mb-2" id="username{{slotIndex}}" formControlName="slotName" />
                  </span>
                </span>
              </div>

            </div>
          </div>
        </div>

      </div>

    </div>
    <div class="col-12 md:col-6 pb-0">
      <div class="box-card card">
        <div class="upload-plan">
          <h3>Upload Plan</h3>
          <p>Parking plan maximum file size - 25 MB
          </p>
          <div class="main-upload">
            <div *ngIf="upldBtn" class="upload-btn" (drop)="onDrop($event,fileUpload)" (dragover)="onDragOver($event)"
              (dragleave)="onDragLeave($event)">
              <p-fileUpload mode="basic" #fileUpload chooseLabel="Browse Computer" class="custom-ptext"
                (onSelect)="onUpload($event.files,fileUpload)">
                <div class="img-overlap" [style.background-image]="'url(' + imageLink + ')'"></div>

              </p-fileUpload>
              <p>Drag and drop your file</p>
            </div>

          </div>

          <div *ngIf="isProfileImgError">
            <div class="validation-error">File size should be less than 25MB.</div>
          </div>

          <div class="pre-img upload-preimg" style="position: relative;">

            <p-image [src]="imageLink" *ngIf="imageLink" alt="preview-image" class="preview-image"
              [preview]="true"></p-image>

            <span *ngIf="delIcon"><em class="pi pi-times" (click)="deleteDocument()"></em></span>
          </div>
          <a *ngIf="isParkingLotLayoutDoc && pdfUrl" [href]="pdfUrl" target="_blank">

            <span>View Document</span>

          </a>

          <div class="formgrid grid next-btn save-btn">
            <p-button label="Save" (onClick)="createParking()"></p-button>
          </div>
        </div>
      </div>
    </div>

  </div>
</div>